import {inject, Injectable} from '@angular/core';
import {
  hypothesisFilesPath,
  isHypothesisFileType
} from "../../../hypothesis-modal/configs/hypothesis-modal-config";
import {PreviewFileDialogData} from "../../types/preview-file-modal.types";
import {HypothesisFilesStateService} from "../../../hypothesis-modal/services/hypothesis-files-state.service";
import {HypothesisFilesService} from "../../../hypothesis-modal/services/hypothesis-files.service";
import {HypothesisFileTypeName, UpdateFieldCommentFile} from "../../../../../types/file.types";
import {
  UpdateHypothesisFileCommentParams
} from "../../../hypothesis-modal/types/hypothesis-modal.types";

@Injectable({
  providedIn: 'root'
})
export class PreviewFileService {
  private hypothesisFilesStateService: HypothesisFilesStateService = inject(HypothesisFilesStateService);
  private hypothesisFilesService: HypothesisFilesService = inject(HypothesisFilesService);

  public getComment(previewFileDialogData: PreviewFileDialogData): string | null {
    if (!previewFileDialogData.fileId || !isHypothesisFileType(previewFileDialogData.fileType)) {
      return null;
    }

    return this.hypothesisFilesStateService.getHypothesisFileCommentByFileId({
      type: previewFileDialogData.fileType,
      fileId: previewFileDialogData.fileId
    });
  }

  public getHypothesisFileDataId(previewFileDialogData: PreviewFileDialogData): number {
    return this.hypothesisFilesStateService.getHypothesisFileId({
      type: previewFileDialogData.fileType as HypothesisFileTypeName,
      fileId: previewFileDialogData.fileId || 0
    })
  }

  public async updateHypothesisFileData(updateFieldCommentFile: UpdateFieldCommentFile ): Promise<void> {
    const data = await this.hypothesisFilesService.updateCommentHypothesisFile(updateFieldCommentFile).catch(() => null);

    data && this.setHypothesisFileData({
      type: data.type,
      fileId: data.file.id,
      comment: data.comment
    });
  }

  public setHypothesisFileData(updateHypothesisFileCommentParams: UpdateHypothesisFileCommentParams) {
    this.hypothesisFilesStateService.updateHypothesisFileCommentByFileId(updateHypothesisFileCommentParams);
  }

  public setTextDialogData(previewFileDialogData: PreviewFileDialogData) {
    return {
      path: hypothesisFilesPath,
      modalName: `Текст файла с Id: ${previewFileDialogData.fileId}`,
      recordId: this.getHypothesisFileDataId(previewFileDialogData),
      key: 'comment',
      fieldLabel: 'Комментарий',
      content: this.getComment(previewFileDialogData)
    };
  }
}
